import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DealsFormOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/deal-form/deal-form-wrapper.component';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';

//declare var SockJS: any;
@Component({
  selector: 'app-deal-form-mobile',
  templateUrl: './deal-form-mobile.component.html',
  styleUrls: ['./deal-form-mobile.component.scss'],
})
export class DealFormMobileComponent extends DealsFormOpenQuoteWrapper {
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }
}
